import { css } from '@lastbrand/web-ui-styled-system/css'

/* eslint-disable i18next/no-literal-string -- Panda tokens / CSS literals, not user-facing copy */

// marginBottom owns the uniform title→body gap for every account page (24 mobile / 32 desktop).
// paddingInline is the mobile gutter, flush from lg up (matches the account content column).
export const styledPageHeaderClass = css({
  paddingInline: 'space-16',
  paddingBlock: 0,
  marginBottom: 'space-24',
  lg: { paddingInline: 0, marginBottom: 'space-32' },
})

// color:'black' is the DS neutral-black token (#21201f). title-24-dec carries font only, so without it the
// title inherits the surrounding text color (pure #000000), not the Figma neutral-black.
export const titleClass = css({
  textStyle: 'title-24-dec',
  color: 'black',
})

export const textClass = css({
  textStyle: 'body-12',
  marginTop: 'space-24',
  lg: { width: '480px' },
})

/* eslint-enable i18next/no-literal-string */
